export default __webpack_public_path__ + "static/favicon-df9b6ac2c37ee359c1adf3058eb2fc96.ico";